import { useLocation } from 'react-router-dom';

import { financialOverviewSteps } from '@/constants/tour/financial-overview';
import { homeSteps } from '@/constants/tour/home';
import { librarySteps } from '@/constants/tour/library';
import { territoriesSteps } from '@/constants/tour/territories';

import { useFinancialOverviewTour } from './useFinancialOverviewTour';
import { useHomeTour } from './useHomeTour';
import { useLibraryTour } from './useLibraryTour';
import { useTerritoriesTour } from './useTerritoriesTour';

export const useTourManager = () => {
  const { pathname } = useLocation();

  // Initialize all tour hooks
  const homeTour = useHomeTour({ steps: homeSteps });
  const libraryTour = useLibraryTour({ steps: librarySteps });
  const territoriesTour = useTerritoriesTour({
    steps: territoriesSteps,
    eventName: 'start-territories-tour',
  });
  const financialTour = useFinancialOverviewTour({
    steps: financialOverviewSteps,
    eventName: 'startFinancialOverviewTour',
  });

  // Determine current tour based on route
  const getCurrentTour = () => {
    if (pathname === '/dashboard' || pathname === '/dashboard/') {
      return { tour: homeTour, steps: homeSteps };
    } else if (pathname.includes('/dashboard/library')) {
      return { tour: libraryTour, steps: librarySteps };
    } else if (pathname.includes('/dashboard/territories')) {
      return { tour: territoriesTour, steps: territoriesSteps };
    } else if (pathname.includes('/dashboard/financial-overview')) {
      return { tour: financialTour, steps: financialOverviewSteps };
    }
    return null;
  };

  const currentTourData = getCurrentTour();

  return {
    currentTour: currentTourData?.tour || null,
    currentSteps: currentTourData?.steps || [],
    hasTour: !!currentTourData,
  };
};
